$shm_list_page $mol_page
	add? null
	close? null
	head /
		<= List_head $shm_list_head
			title <= title
			Title => Head_title
			head_content <= head_content /$mol_view_content
				<= Head_title
			filter? <=> filter? \
			Filter <= Search $mol_search
				query? <=> filter?
				hint <= filter_hint \Поиск...
			add_title <= add_title \Добавить
			add_content <= add_content /$mol_view
			add? <=> add_run? null
			close_hint <= close_hint \Закрыть
			close_content <= close_content /$mol_view
			close? <=> close_run? null
			settings_hint \Сортировка
			sort_by? <=> sort_by? \title
			sort_order? <=> sort_order? \asc
			sort_options <= sort_options *string
				title \Наименование
